import SearchFilterRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest";
import FilterRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/FilterRequest";
import SearchRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/SearchRequest";
import IFilterModel from "../IFilterModel";



export default class MusicFilterModel implements IFilterModel {
    search: string = '';
    isPaid: boolean = null;
    isSleep: boolean = null;
    resetToDefault() {
        this.search = '';
        this.isPaid = null;
        this.isSleep = null;
    }
    toSearchRequest(): SearchRequest[] {
        const res = new Array<SearchRequest>();
        //this.search && res.push(new SearchRequest({FieldName: 'Search', SearchValue: this.search})); // todo
        this.isPaid != null && res.push(new SearchRequest({FieldName: 'IsPaid', SearchValue: this.isPaid.toString()}));
        this.isSleep != null && res.push(new SearchRequest({FieldName: 'IsSleep', SearchValue: this.isSleep.toString()}));
        return res;
    }
    toFilterRequest(): SearchFilterRequest {
        const res = new SearchFilterRequest({
            Name: this.search
        });
        res.Search = this.toSearchRequest();
        return res;
    }
}